// @file List of provide/inject keys used in Whiteboard.
// @see https://vuejs.org/guide/components/provide-inject.html#working-with-symbol-keys
// @see https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
import type { InjectionKey, Ref } from 'vue'

const whiteboardEditorZoomKey = Symbol('whiteboardEditorZoom') as InjectionKey<Ref<number>>
const whiteboardAudioPlayerV2Key = Symbol('whiteboardAudioPlayerV2') as InjectionKey<Ref<boolean>>

export { whiteboardAudioPlayerV2Key, whiteboardEditorZoomKey }
